import * as React from "react";
import { forwardRef } from "react";
const SvgCheckboxChecked = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 4H6a2 2 0 00-2 2v20a2 2 0 002 2h20a2 2 0 002-2V6a2 2 0 00-2-2zM14 21.5l-5-5 1.59-1.5L14 18.35 21.41 11 23 12.58l-9 8.92z", fill: "#263238" }));
const ForwardRef = forwardRef(SvgCheckboxChecked);
export { ForwardRef as ReactComponent };
